<template>
  <employee-view-content
    :employee-id="$store.getters.user.id"
    :user="$store.getters.user"
  />
</template>

<script>
import EmployeeViewContent from './EmployeeViewContent.vue'
export default {
  components: {
    'employee-view-content': EmployeeViewContent
  }
}
</script>
